import {Component, OnDestroy, OnInit} from '@angular/core';
import {MenuNavigationService} from "../../../../../services/menu-navigation.service";
import {BehaviorSubject, Subscription} from "rxjs";
import {UserService} from "../../../../../services/user.service";
import {SubscriptionService} from "../../../../../services/subscription.service";

@Component({
  selector: 'app-aside-menu',
  templateUrl: './aside-menu.component.html',
  styleUrls: ['./aside-menu.component.scss'],
})
export class AsideMenuComponent implements OnInit, OnDestroy {

  subscribeOnBoarding: Subscription;
  showMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  g: boolean = false;

  private domainWhitelist: string[] = [
    'qr-pay.net',
    'nulead.co.uk',
    'updev.agency'
  ];

  constructor(
    public navService: MenuNavigationService,
    public user: UserService,
    public subscription: SubscriptionService
  ) {}

  ngOnInit(): void {
    this.subscribeOnBoarding = this.subscription.onboardingFlags.subscribe((data: any)=>{
      if(data && data.BrandActive && data.BrandActive > 0){
        this.showMenu.next(true)
      }
    });

    this.user.currentUserSubject.subscribe((user) => {
        this.g = this.checkDomain(user.email);
    });
  }

  ngOnDestroy() {
    this.subscribeOnBoarding.unsubscribe();
  }

  public checkDomain(email: string): boolean {
    // Extract the domain from the email
    const domain = email.split('@')[1];

    // Check if the extracted domain is in the whitelist
    if (this.domainWhitelist.includes(domain)) {
      console.log("PASS");
      return true;
    } else {
      console.log("FAIL");
      return false;
    }
  }

}
